"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowHide = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ShowHideButton = require("../ShowHideButton/ShowHideButton");
var _ShowHideHidden = require("../ShowHideHidden/ShowHideHidden");
var _withUncontrolled = require("./withUncontrolled");
/**
 * Disclosable content should be wrapped with `ShowHide.Hidden` to ensure expected behavior.
 * `ShowHide.Hidden` can be used in multiple places and all contents will be toggled with
 * button press. Only single child is allowed inside `ShowHide`, otherwise an error will be thrown.
 *
 * See `ShowHideWordCount` if the content is a string type and an automatic truncation based
 * on word count is preferred.
 *
 * W3C uses [`Disclosure`](https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure)
 * to refer similar behavior.
 *
 * @subcomponents ['ShowHideWordCount']
 * @since 8.36.0
 */
var ShowHide = (0, _withUncontrolled.withUncontrolled)( /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var appearance = _ref.appearance,
    children = _ref.children,
    renderButton = _ref.renderButton,
    isHidden = _ref.isHidden,
    onClick = _ref.onClick;
  /**
   * EVENT HANDLER
   */
  var onClickCallback = (0, _react.useCallback)(function () {
    if (onClick) {
      onClick(isHidden);
    }
  }, [isHidden, onClick]);

  /**
   * RENDER
   */

  // render toggle button
  var button = renderButton;
  if (typeof renderButton === 'function') {
    button = renderButton({
      appearance: appearance,
      isHidden: isHidden,
      ref: forwardedRef,
      onClick: onClickCallback
    });
  }

  // render children
  var content = _react.Children.toArray(_react.Children.only(children).props.children);
  content = content.map(function (child, index) {
    if (!child.type || child.type.displayName !== 'ShowHideHidden') {
      return child;
    }
    return /*#__PURE__*/(0, _react.cloneElement)(child, Object.assign({}, child.props, {
      isHidden: isHidden,
      // eslint-disable-next-line zillow/react/no-array-index-key
      key: index
    }));
  });
  if (appearance === 'inline') {
    content = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, content, isHidden ? " ..." : null, " ", " ", button);
  }
  var newChildren = /*#__PURE__*/(0, _react.cloneElement)(children, Object.assign({}, children.props, {
    children: content
  }));
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, newChildren, appearance === 'block' ? button : null);
}));
exports.ShowHide = ShowHide;
ShowHide.displayName = 'ShowHide';
ShowHide.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type of ShowHide to display.
   */
  appearance: _propTypes.default.oneOf(['inline', 'block']).isRequired,
  /**
   * The visibility of disclosable content will be controlled by button press.
   */
  children: _propTypes.default.element.isRequired,
  /**
   * A ShowHide is uncontrolled by default.
   * You can specify `isHidden` to manually control the visibility of disclosable content.
   */
  // This prop will be added in withUncontrolled but will need to be exposed in the doc.
  defaultHidden: _propTypes.default.bool,
  /**
   * A ShowHide is uncontrolled by default.
   * You can specify `isHidden` to manually control the visibility of disclosable content.
   */
  isHidden: _propTypes.default.bool,
  /**
   * Function called when button is pressed.
   */
  onClick: _propTypes.default.func,
  /**
   * Default button styling corresponding to the `appearance` prop.
   */
  renderButton: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
} : {};
ShowHide.defaultProps = {
  defaultHidden: true,
  renderButton: function renderButton(props) {
    return /*#__PURE__*/_react.default.createElement(_ShowHideButton.ShowHideButton, props, props.isHidden ? 'See more' : 'See less');
  }
};
ShowHide.Hidden = _ShowHideHidden.ShowHideHidden;